module.exports = __webpack_public_path__ + "img/person.3d048e33.svg";